<template>
  <v-row v-if="ready" class="pt-5">
    <v-col cols="10" offset="1">
      <v-row>
         <v-col cols="4">
      <p>Archetypes</p>
      <bar-pie :id="`archetype-pis`" :data="filteredArchetypesTypes" />
    </v-col>
    <v-col cols="8">
      <p>Personalities</p>
      <bar-graph :id="`people`" :data="filteredArchetypesPersonalities" />
    </v-col>
    
        <v-col cols="6" v-for="item in filteredArchetypesTypes" :key="item.el">
          <v-card light class="mb-0">
            <v-card-text>
              <p class="overline">Archetype</p>
              <v-row>
                <v-col cols="4">
                  <h2>{{ item.el }}</h2>
                  <p class="mt-3 mb-1 caption">Score</p>
                  <v-chip color="amber">{{ item.count }}</v-chip>
                </v-col>
                <v-col cols="8">
                  <dl>
                    <dt>Goal</dt>
                    <dd>{{ item.text.goal }}</dd>
                    <dt>Strategy</dt>
                    <dd>{{ item.text.strategy }}</dd>
                    <dt>Fear</dt>
                    <dd>{{ item.text.fear }}</dd>
                    <dt>Personalities</dt>
                    <dd>{{ item.text.personalities }}</dd>
                    <dt>Attributes</dt>
                    <dd>{{ item.text.attributes }}</dd>
                  </dl>
                </v-col>
                <v-col cols="12">
                  <v-divider></v-divider>
                  <p class="overline mt-2">Personalities</p>
                  <div class="tray">
                    <div
                      class="item"
                      v-for="(inner, index) in getPersonalities(item.el)"
                      :key="`${item.el}-${index}`"
                    >
                      <v-img class="img" :src="inner.src" />
                      <p>{{ inner.el }}</p>
                    </div>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
const fb = require("@/firebaseConfig.js");
import lodash from "lodash";
import { mapState } from "vuex";
import { store } from "@/store.js";
import { BarPie, BarGraph } from "@/components/graphs";

export default {
  name: "ResultsMessagesSummary",
  data() {
    return {
      doc: null,
      intervalId: null,
      ready: false,
      max: 0,
      max2: 0,
    };
  },
  props: {
    id: String,
    summaryMode: {
      type: String,
      default: "combined",
    },
  },
  components: {
    BarPie,
    BarGraph,
  },
  mounted() {
    this.getList();
    this.init();
  },
  computed: {
    ...mapState([
      "exArchetypes",
      "exArchetypesSummary",
      "exTypes",
      "archetypes",
    ]),
    filteredArchetypesPersonalities() {
      let items = [];
      let distribution = this.exArchetypesSummary.reduce(
        (acum, cur) =>
          Object.assign(acum, {
            [cur.archetype[0].name]: (acum[cur.archetype[0].name] | 0) + 1,
          }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.title = item.el;
      });
      return items;
    },
    filteredArchetypesTypes() {
      let items = [];
      let distribution = this.exArchetypesSummary.reduce(
        (acum, cur) =>
          Object.assign(acum, {
            [cur.type.title]: (acum[cur.type.title] | 0) + 1,
          }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.text = this.getTxt(item.el);
        item.title = item.el;
      });
      return lodash.orderBy(items, "count", "desc");
    },
  },
  methods: {
    init() {
      let vm = this;
      clearInterval(this.intervalId);
      this.intervalId = null;
      this.intervalId = setInterval(function() {
        vm.checkStatus();
      }, 300);
    },
    checkStatus() {
      if (this.exArchetypes && this.archetypes) {
        // this.setMax();
        // this.setMax2();
        this.ready = true;
        clearInterval(this.intervalId);
      }
    },
    setMax() {
      this.max = Math.max.apply(
        null,
        this.filteredTypes.map((item) => item.count)
      );
      console.log("max=", this.max);
    },
    setMax2() {
      this.max2 = Math.max.apply(
        null,
        this.filteredPersonalities.map((item) => item.count)
      );
      console.log("max=", this.max2);
    },
    getList() {
      let ref = fb.archetypesCollection;
      ref
        .get()
        .then((result) => {
          let items = [];
          result.docs.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          if (items) {
            store.commit("setArchetypes", items);
          }
        })
        .catch(function() {});
    },
    getPersonalities(key) {
      let list = this.exArchetypesSummary.filter((x) => x.type.title == key);
      let items = [];
      let distribution = list.reduce(
        (acum, cur) =>
          Object.assign(acum, {
            [cur.archetype[0].name]: (acum[cur.archetype[0].name] | 0) + 1,
          }),
        {}
      );
      for (var element in distribution) {
        items.push({ el: element, count: distribution[element] });
      }
      items.map((item) => {
        item.src = this.getImg(item.el);
      });
      return items;
    },
    getImg(element) {
      let item = this.archetypes.find((x) => x.name == element);
      return item.src;
    },
    getTxt(element) {
      let item = this.$t("exercise_archetypes.types").find(
        (x) => x.title == element
      );
      return item;
    },
    getPercentage(count) {
      let unit = 100 / this.max;
      return `${count * unit}%`;
    },
    getPercentage2(count) {
      let unit = 100 / this.max2;
      return `${count * unit}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
.tray {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 100px;
    margin-right: 2px;
    p {
      line-height: 1.2;
      margin-top: 0.5rem;
      font-weight: 500;
    }
  }
}
.img {
  width: 100px;
  height: auto;
}
dt {
  font-weight: 500;
}
</style>
